import {
  CommonParamsType,
  CommonSuccessResponse,
} from "constants/types/common";
import { PurchaseOrderResponseType } from "constants/types/purchaseOrder";
import useSWR from "swr";
import { serialize } from "utils/validation/string";

export const getPurchaseOrderListKey = (params?: CommonParamsType) => {
  return `/purchase-order?${serialize({ ...params })}`;
};

export const usePurchaseOrders = (params?: CommonParamsType) => {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data: CommonSuccessResponse<PurchaseOrderResponseType[]> | undefined;
    error: any;
    isLoading: boolean;
    mutate: any;
  } = useSWR(getPurchaseOrderListKey(params), { refreshInterval: 0 });

  const pagination = data?.meta;
  const purchaseOrders = data?.data;

  return {
    purchaseOrders,
    pagination,
    error,
    isLoading,
    mutate,
  };
};

export const usePurchaseOrderDetail = (id: string | undefined) => {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data: CommonSuccessResponse<PurchaseOrderResponseType> | undefined;
    error: any;
    isLoading: boolean;
    mutate: any;
  } = useSWR(id ? `/purchase-order/${id}` : null, {
    refreshInterval: 5000,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  return {
    purchaseOrder: data?.data,
    error,
    isLoading,
    mutate,
  };
};
